import React, { createContext, useContext, useState, useEffect } from 'react';

export const EditContext = createContext();

export function EditProvider({ children }) {
  const [editMode, setEditMode] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (isAdmin) {
      setEditMode(true);
    } else {
      setEditMode(false);
    }
  }, [isAdmin]);

  const checkAuth = async () => {
    try {
      const res = await fetch('/api/admin/check', { credentials: 'include' });
      const data = await res.json();
      setIsAdmin(data.authenticated);
    } catch (e) {
      setIsAdmin(false);
    }
  };

  return (
    <EditContext.Provider value={{ editMode, setEditMode, isAdmin, checkAuth }}>
      {children}
    </EditContext.Provider>
  );
}

export function useEditMode() {
  return useContext(EditContext);
}
